import type { coolModelConfig, StatusMapping } from './types';
import { coolConfigs } from './configs/bytedance';
import { minimaxConfigs } from './configs/minimax';

/**
 * cool API 路径配置（所有模型统一使用）
 */
export const coolApiPaths = {
    /** 创建任务 API 路径 */
    createTask: '/v1/cool/generate',
    /** 轮询任务 API 路径 */
    pollTask: '/v1/cool/task',
};

/**
 * cool 状态映射配置（所有模型统一使用）
 */
export const coolStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'task_id',
    /** 状态字段路径 */
    statePath: 'status',
    /** 成功状态值 */
    success: ['success'],
    /** 失败状态值 */
    failed: ['failed'],
    /** 处理中状态值 */
    processing: ['pending', 'running'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'result.url',
    /** 错误信息字段路径 */
    errorPath: 'error',
};

/**
 * 模型配置映射
 */
export const coolModelConfigs: Record<string, coolModelConfig> = {
    ...coolConfigs,
    ...minimaxConfigs,
};
